goog.provide('el8.appchart.navtriggers');

goog.require('el8.appchart.dialog.addEditPatientTags');
goog.require('el8.appchart.dialog.cqmDashboardDialog');
goog.require('el8.appchart.dialog.documentVitals');
goog.require('el8.appchart.dialog.growthChart');
goog.require('el8.appchart.dialog.manualLabEntry');
goog.require('el8.appchart.dialog.order.viewLabOrderSets');
goog.require('el8.appchart.dialog.ordermed.document');
goog.require('el8.appchart.dialog.ordermed.newDocumentDiscontinue');
goog.require('el8.appchart.dialog.ordermed.samples');
goog.require('el8.appchart.dialog.ordermed.viewRxOrderSets');
goog.require('el8.appchart.dialog.reports');
goog.require('el8.appchart.dialog.viewAllTemplates');
goog.require('el8.appchart.mainFeeds.chart');
goog.require('el8.appchart.medsHx.main');
goog.require('el8.appchart.mgr.notes');
goog.require('el8.appchart.mgr.orderForm');
goog.require('el8.appchart.mgr.thirdpane');
goog.require('el8.appchart.permissions');
goog.require('el8.appchart.providers.main');
goog.require('el8.appchart.refpanel.allergies');
goog.require('el8.appchart.refpanel.confidential');
goog.require('el8.appchart.refpanel.demog');
goog.require('el8.appchart.refpanel.history');
goog.require('el8.appchart.refpanel.intols');
goog.require('el8.appchart.refpanel.maint');
goog.require('el8.appchart.refpanel.meds');
goog.require('el8.appchart.refpanel.family');
goog.require('el8.appchart.refpanel.problems');
goog.require('el8.appchart.refpanel.prenatalFlowsheets');
goog.require('el8.appchart.refpanel.providers');
goog.require('el8.appchart.refpanel.compareRefpanel');
goog.require('el8.appchart.refpanel.util');
goog.require('el8.appchart.showItemDetail');
goog.require('el8.appchart.visitNote.viewTemplatesDialog');
goog.require('el8.appchart.dialog.implantableDeviceList');
goog.require('el8.practicedata.immunizationRegistries');
goog.require('el8.practicedata.letterTemplates');
goog.require('el8.ptdata.medOrders');
goog.require('el8.ptdata.visitNote2s');
goog.require('el8.service.tooltip');
goog.require('el8.service.urls');
goog.require('el8.core.uiwidget.SubmenuGroup');
goog.require('el8.util.amplitude.helpers');
goog.require('el8.util.amplitude.immunizationHelpers');
goog.require('el8.util.amplitude.prescriptionFormHelpers');
goog.require('el8.util.amplitude.patientChartHelpers');
goog.require('el8.util.amplitude.collaborativePracticeHelpers');
goog.require('el8.util.amplitude.patientFormHelpers');
goog.require('el8.util.amplitude.dataExchangeHelpers');


el8.appchart.navtriggers = (function() {

    var _SubmenuGroup = new el8.core.uiwidget.SubmenuGroup();

    return {

        setup: function() {

            this._setupOrderTriggers();

            var $provTrigger = $('#providers_trigger');
            $(document).on('click', '#providers_trigger',  function(e) {
                el8.appchart.providers.main.toggle();
            });

            $(document).on('click', '.meds_history_trigger', function(event) {
                event.preventDefault();
                el8.appchart.medsHx.main.show();
            });

             $(document).on('click', '.check-pmp-trigger', function(event) {
                event.preventDefault();
                el8.appchart.medsHx.main.triggerCheckPmp($(event.target).attr('data-amplitude-source'));
            });

            $(document).on('click', '.patient-info-trigger',  function(event) {
                event.preventDefault();
                if (el8Globals.FEATURES.NewDemographics) {
                    el8.util.amplitude.logEvent('Demographics - open edit dialog from patient name in clinical profile');
                    el8React.dispatch.openEditPatientDialog({
                        patientId: el8Globals.PATIENT_ID
                    });
                } else {
                    el8.appshared.dialog.editPatient.show();
                }
            });

            $(document).on('click', '.growth-chart-trigger',  function() {
                el8.appchart.dialog.growthChart.show();
            });

            $(document).on('click', '.vitals-trends-trigger',  function() {
                el8.appchart.mainFeeds.chart.doChartSearch('vitals');
                el8.appchart.mainFeeds.chart.scrollToMagicTable(); // make sure magic table is visible
                // 2P View with VisitNote open -> show chart feed so the results are visible
                if (el8.appchart.layout.getViewMode() === 'small' &&
                        el8.appchart.mgr.notes.visitNoteIsShowing()) {
                    el8.appchart.layout.displayFeed();
                }
            });

            $(document).on('click', '.erx-detail-trigger',  function(e) {
                var itemId = $(this).data('id');
                var order = el8.ptdata.medOrders.getById(itemId);
                el8.appchart.showItemDetail(order);
                return false;
            });

            $(document).on('click', '#patient_forms_trigger',  function(event) {
                event.preventDefault();
                el8React.dispatch.openPatientFormsDialog({
                    patientId: el8Globals.PATIENT_ID
                });
                el8.util.amplitude.logOpenSendFormsDialog()
            });
        },

        _setupOrderTriggers: function() {

            var writeSeeOffset = $('#chart-write-see-bar').height() - 5;

            _SubmenuGroup.addSubmenu({
                trigger: $('#more_orders_trigger'),
                menu: $('#more-orders-menu'),
                top: writeSeeOffset
            });

            _SubmenuGroup.addSubmenu({
                trigger: $('#choose_meds_hx_trigger'),
                menu: $('#meds-hx-menu'),
                top: writeSeeOffset
            });

            _SubmenuGroup.addSubmenu({
                trigger: $('#choose_meds_orders_trigger'),
                menu: $('#meds-orders-menu'),
                top: writeSeeOffset
            });

            _SubmenuGroup.addSubmenu({
                trigger: $('#choose_nonvisit_or_manual_lab_trigger'),
                menu: $('#nonvisit-note-menu'),
                top: writeSeeOffset
            });

            _SubmenuGroup.addSubmenu({
                trigger: $('#choose_visit_note_trigger'),
                menu: $('#visit-note-menu'),
                top: writeSeeOffset
            });

            _SubmenuGroup.addSubmenu({
                trigger: $('#choose_letter_trigger'),
                menu: $('#letter-menu'),
                top: writeSeeOffset
            });

            _SubmenuGroup.addSubmenu({
                trigger: $('#misc_write_see_trigger'),
                menu: $('#misc-write-see-menu'),
                top: writeSeeOffset
            });

            _SubmenuGroup.addSubmenu({
                trigger: $('#choose_templates_trigger'),
                menu: $('#templates-menu'),
                top: writeSeeOffset
            });

            _SubmenuGroup.addSubmenu({
                trigger: $('.report_feed_trigger'),
                menu: $('#report-type-write-see-menu'),
                top: writeSeeOffset
            });

            $(document).on('click', '.nonvisit_note_trigger',  function(event) {
                event.preventDefault();
                var type = $(this).attr('_type');
                el8.appchart.mgr.notes.showNonvisitNote({type: type});
            });

            $(document).on('click', '.manual_lab_entry_trigger',  function(event) {
                event.preventDefault();
                el8.appchart.dialog.manualLabEntry.show();
            });

            $(document).on('click', '.jump-to-report-feed-trigger',  function(event) {
                event.preventDefault();
                _SubmenuGroup.hideAll();
                var rTypeId = $(this).data('id');
                var rTypeKey = el8Globals.AVAILABLE_REPORT_TYPES[rTypeId].report_type_label.toLowerCase();
                el8.appchart.dialog.reports.show({ feedName: rTypeKey });
            });

            $(document).on('click', '.letter_trigger',  function(event) {
                event.preventDefault();
                var type = $(this).data('type');
                el8.appchart.mgr.thirdpane.showLetter({
                    type: type,
                    clickSource: $(event.target).attr('ampsource')
                });
            });

            $(document).on('click', '.visit_note_trigger',  function(event) {
                event.preventDefault();
                var type = $(this).attr('_type') || null;
                el8.appchart.mgr.notes.showVisitNote({
                    uiSource: 'Nav Bar',
                    templateType: type
                });
            });
            $(document).on('click', '.visit_note_2_trigger', function (event) {
                event.preventDefault();

                el8.appservice.notifier.notify('Opening note...');

                el8.ptdata.visitNote2s.create({
                    successCb: function onCreateNote2Success(data) {
                        el8.appchart.mgr.thirdpane.showVisitNote2({ noteId: data.id });
                        
                        el8.appservice.notifier.notify('Note opened.');

                        el8.appchart.mainFeeds.reqAct.update();
                    },
                    errorCb: function onCreateNote2Error() {
                        el8.appservice.notifier.clear();
                        el8.uiwidget.alert('Failed to create note');
                    }
                });
            });
            $(document).on('click', '.show_third_pane_trigger',  function(event) {
                event.preventDefault();
                el8.appchart.mgr.thirdpane.maximizeOpenItem();
            });

            $(document).on('click', '.referral_order_trigger',  function(event) {
                event.preventDefault();
                el8.appchart.mgr.thirdpane.showLetter({
                    type: el8.util.consts.REFERRAL_LETTER,
                    clickSource: $(event.target).attr('ampsource')
                });
            });

            $(document).on('click', '.lab_order_trigger',  function(event) {
                el8.util.amplitude.logEvent('start lab', {'source': $(event.target).attr('ampsource')});
                event.preventDefault();
                el8.appchart.mgr.orderForm.showLabOrderForm();
            });

            $(document).on('click', '.imaging_order_trigger',  function(event) {
                event.preventDefault();
                el8.appchart.mgr.orderForm.showImagingOrderForm();
            });

            $(document).on('click', '.cardiac_order_trigger',  function(event) {
                event.preventDefault();
                el8.appchart.mgr.orderForm.showCardiacOrderForm();
            });

            $(document).on('click', '.sleep_order_trigger',  function(event) {
                event.preventDefault();
                el8.appchart.mgr.orderForm.showSleepOrderForm();
            });

            $(document).on('click', '.pulmonary_order_trigger',  function(event) {
                event.preventDefault();
                el8.appchart.mgr.orderForm.showPulmonaryOrderForm();
            });

            $(document).on('click', '.meds_order_trigger',  function(event) {
                event.preventDefault();
                var type = $(this).attr('_type');
                el8.util.amplitude.logStartPrescription(event.target.dataset.amplitudeSource, type);
                el8.appchart.mgr.orderForm.showMedsOrderForm(false, null, type);
            });

            if (el8.appchart.permissions.allow('prescribeMeds')) {
                $(document).on('click', '.samples_med_order_trigger',  function(event) {
                    event.preventDefault();
                    el8.util.amplitude.logStartPrescription(event.target.dataset.amplitudeSource, 'samples');
                    el8.appchart.dialog.ordermed.samples.show();
                });
            } else {
                $('.samples_med_order_trigger').hide();
            }

            $(document).on('click', '.document_med_order_trigger',  function(event) {
                event.preventDefault();
                el8.appchart.dialog.ordermed.document.show();
            });

            $(document).on('click', '.bulk_refill_med_order_trigger',  function(event) {
                event.preventDefault();
                var sectionName = event.target.getAttribute('data-type');
                var threads;
                if (sectionName === 'perm-rx') {
                    threads = el8.ptdata.medOrderThreads.getSortedPermRx(true);
                } else if (sectionName === 'perm-otc') {
                    threads = el8.ptdata.medOrderThreads.getSortedPermOtc(true);
                } else {
                    threads = [];
                }
                el8.appchart.mgr.orderForm.bulkRefillMedOrders(
                    threads.map(function(thread) {
                        return thread.getLatestOrder();
                    })
                );
            });

            $(document).on('click', '.document_dc_med_trigger',  function(event) {
                event.preventDefault();
                el8.appchart.dialog.ordermed.newDocumentDiscontinue.show();
            });

            if (el8Globals.FEATURES.PracticeStripeInt) {
                var clipboard = new ClipboardJS('.copy-payment-details-link-trigger');

                clipboard.on('success', function(e) {
                    el8.appservice.notifier.notify('Payment details link copied.');
                });

                $.el8_ajax({
                    type: 'GET',
                    url: '/patient/' + el8Globals.PATIENT_ID + '/payment-methods/anonymous-url/',
                    success: function(data) {
                        $('.copy-payment-details-link-trigger')
                            .show()
                            .attr('data-clipboard-text', data.url);
                    }
                });
            }

            $(document).on('click', '.data-exchange-trigger',  function(event) {
                event.preventDefault();
                el8.util.amplitude.logClickDataExchange();
                el8.app.shared.dialog.dataExchange.show();
            });
            $(document).on('click', '.pe-templates-trigger',  function(event) {
                event.preventDefault();
                el8.appchart.visitNote.viewTemplatesDialog.show('pe');
            });
            $(document).on('click', '.ros-templates-trigger',  function(event) {
                event.preventDefault();
                el8.appchart.visitNote.viewTemplatesDialog.show('ros');
            });
            $(document).on('click', '.visit-note-templates-trigger',  function(event) {
                event.preventDefault();
                el8.appchart.dialog.visitNoteTemplates.show();
            });
            $(document).on('click', '.lab-orderset-trigger',  function(event) {
                event.preventDefault();
                el8.appchart.dialog.order.viewLabOrderSets.show(true, function(templateId) {
                    el8.appchart.dialog.order.lab.show(false, { orderSetId: templateId });
                });
            });

            if (el8Globals.FEATURES.MedOrderTemplates) {
                $(document).on('click', '.rx-orderset-trigger',  function(event) {
                    event.preventDefault();
                    el8React.dispatch.openPrescriptionTemplateDialog();
                });
            }

            $(document).on('click', '.letter-template-trigger',  function(event) {
                event.preventDefault();
                el8.appchart.dialog.viewAllTemplates.show({
                    templateSet: el8.practicedata.letterTemplates,
                    selectedCb: function(template) {
                        el8.appchart.mgr.thirdpane.useLetterTemplate(template.getId());
                    }
                });
            });
            $(document).on('click', '.implantable-device-list-trigger',  function(event) {
                event.preventDefault();
                el8.appchart.dialog.implantableDeviceList.show();
            });
            $(document).on('click', '.rt-cqm-debug-trigger',  function(event) {
                event.preventDefault();
                el8.appchart.dialog.cqmDashboardDialog.show();
            });

            $(document).on('click', '.educational-handouts-trigger',  function(event) {
                event.preventDefault();
                el8.appshared.dialog.viewEducationalHandouts.show();
            });

            $(document).on('click', '.add-immunization-trigger',  function(event) {
                event.preventDefault();
                var dlg = el8Globals.FEATURES.IRSubmissions
                    ? el8.appchart.dialog.addEditImmunizationNew
                    : el8.appchart.dialog.addEditImmunization;
                dlg.show();
                el8.util.amplitude.logImmunizationDialogOpen($(event.target).attr('data-amplitude-source'));
            });

            $(document).on('click', '.search-immunizations-trigger',  function(event) {
                event.preventDefault();
                el8.appchart.mainFeeds.chart.doChartSearch('vaccines');
                el8.appchart.mainFeeds.chart.scrollToMagicTable();
                el8.util.amplitude.logImmunizationTableOpen($(event.target).attr('data-amplitude-source'));
            });

            $(document).on('click', '.print-immunizations-trigger',  function(event) {
                event.preventDefault();
                el8.appchart.printService.open({
                    attachmentId: 'ImmHistory',
                    url: el8.service.urls.get('printImmunizations')
                });
                el8.util.amplitude.logImmunizationTableButton('print_immhx');
            });

            if (el8.practicedata.immunizationRegistries.canCheckRegistryHistoryForecast()){
                $(document).on('click', '.check-forecast-immunizations-trigger',  function(event) {
                    event.preventDefault();
                    el8.util.amplitude.logImmunizationForecastOpenForecastDialog('immunization table');
                    el8React.dispatch.openImmunizationForecastDialog();
                });
            }

            $(document).on('click', '.schedule-immunizations-trigger',  function(event) {
                el8.util.amplitude.logImmunizationTableButton($(event.target).attr('data-amplitude-schedule'));
            });

            $(document).on('click', '.doc-vitals-trigger',  function(event) {
                event.preventDefault();
                el8.appchart.dialog.documentVitals.show();
            });

            $(document).on('click', '.print-refpanel-trigger',  function(event) {
                event.preventDefault();
                el8.appchart.printService.open({
                    attachmentId: 'RefPanel',
                    urlKey: 'printRefPanel'
                });
            });


            // Returns a list of the refpanel sections
            var allCollapsibleRefpanelSections = [
                    el8.appchart.refpanel.allergies,
                    el8.appchart.refpanel.intols,
                    el8.appchart.refpanel.problems,
                    el8.appchart.refpanel.prenatalFlowsheets,
                    el8.appchart.refpanel.history,
                    el8.appchart.refpanel.meds,
                    el8.appchart.refpanel.providers,
                    el8.appchart.refpanel.confidential,
                    el8.appchart.refpanel.maint];

            $(document).on('click', '.collapse-refpanel-trigger',  function(event) {
                event.preventDefault();
                _.each(allCollapsibleRefpanelSections,
                       function(section) {section.collapse();});
                $('.collapse-refpanel-trigger').hide();
                $('.expand-refpanel-trigger').show();
            });

            $(document).on('click', '.expand-refpanel-trigger',  function(event) {
                event.preventDefault();
                _.each(allCollapsibleRefpanelSections,
                       function(section) {section.expand();});
                $('.expand-refpanel-trigger').hide();
                $('.collapse-refpanel-trigger').show();
            });

            if (el8Globals.FEATURES.OutsideCare || el8Globals.FEATURES.ZusOutsideCare) {
                $(document).on('click', '.outside-care-refpanel-trigger', function(event){
                    event.preventDefault();
                    el8React.dispatch.openOutsideCareConsentController();
                });
            }

            if (el8.practicedata.immunizationRegistries.canCheckRegistryHistoryForecast()) {
                $(document).on('click', '.immunization-history-dialog-trigger', function(event){
                    event.preventDefault();
                    el8.util.amplitude.logImmunizationHistoryOpenHistoryDialog('clinical profile');
                    el8React.dispatch.openImmunizationHistoryDialog();
                });
            }

            $(document).on('click', '.patient-tags',  function(event) {
                event.preventDefault();
                el8.appchart.dialog.addEditPatientTags.show();
            });

            $(document).on('click', '.compare-refpanel-trigger',  function(event) {
                event.preventDefault();
                el8.util.amplitude.logClinicalProfileUpdateButtonPressed(el8.appchart.refpanel.compareRefpanel.getIsClinicalProfileUpdated());
                el8.appchart.refpanel.compareRefpanel.show();
            });
        }

    };

})();
